export const SourceChannelsDomainDropdown = [
  { id: 'template', name: 'Product Template' },
  { id: 'url', name: 'Image URL' },
  { id: 'upload', name: 'File Upload' },
  { id: 'text', name: 'HTML Content' }
]

export const SourceChannels = {
  template: 'template', text: 'text', upload: 'upload', url: 'url'
}



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/StaticData/SourceChannels.tsx